import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../utils/Utils.js';
import DataCollectionAdd from '../shared/DataCollectionAdd.js';
import DateInput from '../shared/inputs/DateInput.js';
import ProjectDropdown from '../shared/dropdowns/ProjectDropdown.js';

const AddFinanceForm = ({ categories, institutions, projects }) => {
  const { t } = useTranslation();
  return (
    <>
      <select name="type" required defaultValue="">
        <option value="" disabled>{t('select_type')}</option>
        <option value="gain">{t('gain')}</option>
        <option value="loss">{t('loss')}</option>
      </select>
      <input type="number" name="amount" step="0.01" min="0.01"
             placeholder={t('amount')} required />
      <select name="category" required defaultValue="">
        <option value="" disabled>{t('select_category')}</option>
        {categories.map(c => (
          <option key={c._id || c.name} value={c.name}>{t(c.name, { defaultValue: c.name })}</option>
        ))}
      </select>
      <select name="institution" required defaultValue="">
        <option value="" disabled>{t('select_institution')}</option>
        {institutions.map(i => (
          <option key={i._id || i.name} value={i.name}>{t(i.name, { defaultValue: i.name })}</option>
        ))}
      </select>
      <input type="text" name="notes" placeholder={t('notes')} />
      <ProjectDropdown name="project_id" defaultValue="" projects={projects} />
      <DateInput name="date" required />
    </>
  );
};

const getBodyFromForm = (formData) => {
  return JSON.stringify({
    type:        formData.get('type'),
    amount:      Number(formData.get('amount')),
    category:    formData.get('category'),
    institution: formData.get('institution'),
    notes:       formData.get('notes') || '',
    date:        formData.get('date'),
    ...(formData.get('project_id') ? { project_id: formData.get('project_id') } : {}),
  });
};

export const AddFinance = ({ onSuccess }) => {
  const [categories, setCategories] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    Fetch('api/data/finance.categories', 'GET', null,
      (data) => setCategories(data || []),
      () => {}
    );
    Fetch('api/data/finance.institutions', 'GET', null,
      (data) => setInstitutions(data || []),
      () => {}
    );
    Fetch('api/finance/projects', 'GET', null,
      (data) => setProjects(data || []),
      () => {}
    );
  }, []);

  return (
    <DataCollectionAdd
      collection="finance.transactions"
      getBodyFromForm={getBodyFromForm}
      formElements={() => <AddFinanceForm categories={categories} institutions={institutions} projects={projects} />}
      onSuccess={onSuccess}
    />
  );
};

export default AddFinance;
